import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CanDeactivateGuard } from '../../../../../../../angular/ui/confirm-before-leave/can-deactivate-guard.service';
import { CourseListComponent } from './course-list/course-list.component';
import { LearningGuard } from './learning.guard';
import { routes } from './routes';
import { SharedComponentsModule } from '@cna/projects/ak-jura/angular/my-ak-jura/shared-components';
import { LearningViewComponent } from './learning-view/learning-view.component';
import { LearnstateViewComponent } from './learnstate-view/learnstate-view.component';
import { LearningModuleOverviewViewComponent } from './learning-module-overview-view/learning-module-overview-view.component';
import {
    NgbAccordionModule,
    NgbButtonsModule,
    NgbCarouselModule,
    NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';
import { LearningControlViewComponent } from './learning-control-view/learning-control-view.component';
import { FormsModule } from '@angular/forms';
import { CertificateService } from './services/certificate.service';
import { TestFormComponent } from './test-form/test-form.component';
import { AngularUiPipesModule } from '@cna/angular/ui/pipes';
import { NgLetModule } from '@ngrx-utils/store';

@NgModule({
    imports: [
        CommonModule,
        NgbNavModule,
        RouterModule.forChild(routes),
        SharedComponentsModule,
        NgbCarouselModule,
        FormsModule,
        NgbAccordionModule,
        NgbButtonsModule,
        AngularUiPipesModule,
        NgLetModule,
    ],
    providers: [
        NgbNavModule,
        CourseListComponent,
        LearnstateViewComponent,
        LearningViewComponent,
        LearningModuleOverviewViewComponent,
        CanDeactivateGuard,
        LearningGuard,
        CertificateService
    ],
    declarations: [
        LearningViewComponent,
        LearningModuleOverviewViewComponent,
        LearningControlViewComponent,
        TestFormComponent,
    ],
})
export class LearnModule {}
